import { IUserToken } from '@module/authentication/models';
import { IUser } from '@module/userManagement/models';

class UserDataServiceClass {
    private basePath: string;

  constructor() {
    this.basePath = `${environmentSettings.apiUrl}Users`;
  }

  async getUsers(user: IUserToken): Promise<IUser[]> {
    const response = await this.sendRequest(user, '', 'GET');
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
  }

  async getUserById(userId: number, user: IUserToken): Promise<IUser> {
    const response = await this.sendRequest(user, `/${userId}`, 'GET');
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
  }

  async createUser(newUser: IUser, user: IUserToken): Promise<number> {
    const response = await this.sendRequestBody(user, '', 'POST', newUser);
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
  }

  async updateUser(updatedUser: IUser, user: IUserToken): Promise<number> {
    const response = await this.sendRequestBody(user, '', 'PUT', updatedUser);
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
  }

  async deleteUser(userId: number, user: IUserToken): Promise<IUser[]> {
    const response = await this.sendRequest(user, `/${userId}`, 'DELETE');
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
  }

  private sendRequest(user: IUserToken, url: string, httpMethod: string) {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + user.access_token);
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
    return fetch(`${this.basePath}${url}`, { headers, method: httpMethod, cache: 'no-store' });
  }

  private sendRequestBody(user: IUserToken, url: string, httpMethod: string, body: any) {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + user.access_token);
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('Content-Type', 'application/json');
    headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
    return fetch(`${this.basePath}${url}`, { headers, method: httpMethod, cache: 'no-store', body: JSON.stringify(body) });
  }
}

export const UserDataService = new UserDataServiceClass();
export default UserDataService;



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/services/userDataService.ts